import { Image } from "@chakra-ui/react";
import CssIcon from "./css.svg";
interface Props {
  color?: string;
  boxSize?: string;
}
export const Css = (props: Props) => <Image boxSize={props.boxSize} src={CssIcon} />;

export default Css;
